<template>
  <b-modal
    title="NOVA PERGUNTA"
    no-close-on-backdrop
    hide-footer
    id="new_question"
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <b-form method="post" @submit.prevent="evOnSubmit">
        <b-row>
          <b-col>
            <h6 class="upper-text">Modelo: <label-required-field /></h6>
            <b-select v-model="question_type" @input="evOnQuestionTypeInput">
              <b-select-option
                v-for="qt in question_types"
                :key="qt.id"
                :value="qt"
              >
                {{ qt.name }}
              </b-select-option>
            </b-select>
            <small class="text-muted">{{ question_type.description }}</small>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-checkbox v-model="mandatory">Obrigatória</b-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="upper-text">Enunciado: <label-required-field /></h6>
            <b-textarea
              rows="3"
              ref="autofocus"
              v-model="statement"
              placeholder="Digite o Enunciado"
            />
          </b-col>
        </b-row>
        <b-form
          @submit.prevent="evOnAddAlternativeSubmit"
          v-if="question_type.value != 'OPEN'"
        >
          <h6 class="mb-0">ADICIONAR ALTERNATIVAS:</h6>
          <b-row align-v="center">
            <b-col>
              <b-input
                placeholder="DIGITE A ALTERNATIVA"
                ref="new_alternative"
                v-model="new_alternative"
              />
            </b-col>
            <b-col cols="auto">
              <v-btn type="submit" class="btn-add-down">
                <i class="fas fa-arrow-down mr-2 text-twenty" /> ADICIONAR
              </v-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div v-if="alternatives.length > 0">
                <div
                  class="mb-2"
                  v-for="(item, index) in alternatives"
                  :key="index"
                >
                  <b-input-group>
                    <b-input v-model="alternatives[index]" />
                    <template #append>
                      <v-btn
                        @click="removeAlternative(index)"
                        class="btn-delete ml-1"
                      >
                        <i class="fas fa-trash text-fifteen" />
                      </v-btn>
                    </template>
                  </b-input-group>
                </div>
              </div>
              <div v-else class="text-center p-5 v-clean">
                <h6 class="text-center upper-text worksansr mb-0">
                  Nenhuma alternativa adicionada
                </h6>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <warning-required-fields />
        <errors-messages :errors="errors" />
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn type="submit" class="btn-two-add">
              <i class="fas fa-plus mr-2 text-twenty"></i>
              ADICIONAR
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "NewQuestion",
  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },
  props: {
    form_id: [String, Number],
    category_id: [String, Number],
  },
  data() {
    return {
      errors: [],
      loading: false,
      question_types: [],
      question_type: {},
      statement: "",
      mandatory: true,
      alternatives: [],
      new_alternative: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/semiology/form/question-types"
        );
        const { error, errors, question_types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.question_types = question_types;
          this.question_type = this.question_types[0];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.question_type = this.question_types[0];
      this.statement = "";
      this.mandatory = true;
      this.alternatives = [];
      this.new_alternative = "";
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnQuestionTypeInput() {
      this.errors = [];
      this.alternatives = [];
    },

    async evOnAddAlternativeSubmit() {
      if (!this.new_alternative) {
        this.$refs.new_alternative.focus();
        this.errors = ["Informe a alternativa"];
        return;
      }
      if (
        this.question_type.value == "DICHOTOMOUS" &&
        this.alternatives.length >= 2
      ) {
        this.$refs.new_alternative.focus();
        this.errors = ["Somente duas alternativas são possíveis em dicotômica"];
        return;
      }
      this.errors = [];
      this.alternatives.push(this.new_alternative);
      this.new_alternative = "";
      this.$refs.new_alternative.focus();
    },

    async removeAlternative(index) {
      this.alternatives.splice(index, 1);
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (this.question_type.value != "OPEN" && this.alternatives.length == 0)
          this.errors.push("Informe as alternativas");

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        let data = {
          form_id: this.form_id,
          category_id: this.category_id,
          type_id: this.question_type.id,
          statement: this.statement,
          mandatory: this.mandatory,
          alternatives: this.alternatives,
        };
        let response = await api.post(
          "/rest-home/semiology/form/category/question",
          data
        );
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$emit("created");
          toast(message, "success");
          this.$bvModal.hide("new_question");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
